import $ from 'jquery';
import 'scrollmagic';

$(function () {
  function rangeNavHeight() {
    if ($(window).width() >= 768) {
      return $('.range-nav').first().outerHeight();
    } else {
      return 24;
    }
  }

  $('.range-nav a[href*="#"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .on('click', function (event) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        event.preventDefault();
        $('html, body').animate(
          {
            scrollTop: target.offset().top - rangeNavHeight(),
          },
          400,
        );
      }
    });

  if ($('.ranges').length) {
    var controller = new ScrollMagic.Controller();

    setTimeout(function () {
      $('.range').each(function (i) {
        var index = i + 1;
        var sectionHeight = $(this).outerHeight();

        var scene = new ScrollMagic.Scene({ triggerElement: this, duration: sectionHeight })
          .setClassToggle('#nav-' + index, 'active')
          // .addIndicators()
          .addTo(controller);
      });
    }, 500);
  }
});
